@use '@/scss/underscore' as _;

.terms {
  @include _.flex-row;
  width: 100%;
  user-select: none;
  cursor: pointer;
}

.checkbox {
  margin-right: _.unit(2);
  fill: var(--color-type-secondary);
  cursor: pointer;
}

.content {
  @include _.text-hint;
  font: var(--font-body-3);
}

.errorMessage {
  margin-top: _.unit(2);
}


:global(body.mobile) {
  .terms {
    padding: _.unit(1) 0;
  }
}
